import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddiconList } from 'src/app/components/authentication/login/login.model';
import { Button, LablesNames, RoutePath, TabNames } from '../../model/enum';

@Component({
  selector: 'app-parts-button',
  templateUrl: './parts-button.component.html',
  styleUrls: ['./parts-button.component.scss']
})
export class PartsButtonComponent implements OnInit {
  showlist: boolean = false;
  showNewlist: boolean = false;
  @Input() name: string;
  @Input() optionList: any[];
  @Input() classActive: string;
  @Input() btnClass: string;
  @Input() innerBtnClass: string;
  @Output() buttonOutputEvent: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() marginClass: string = "mx-1";
  @Input() optionWidth: string = "105px";

  enumButtonName = Button;
  enumItemLablesNames = LablesNames;
  enumTabNames = TabNames;
  routerPath = RoutePath;
  currentTab = ''
  route;

  constructor() { }

  ngOnInit() {
  }

  closeList() {
    this.showlist = false
  }
  closeNewList() {
    this.showNewlist = false
  }
  seletedItem(i: number, item: any) {
    const data = { index: i, data: item }
    this.buttonOutputEvent.emit(data)
  }

}
